import React from 'react';
import styled from 'styled-components';
import humanFormat from 'human-format';
import { listTypes, profileTypes } from './prop-types';
import Avatar from './avatar';
import { recordSimilarContributorsStatistic } from '../../../../services/statistics-service';

const Container = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;

  &:first-of-type {
    margin-top: 24px;
  }

  & img {
    flex-shrink: 0;
  }

  & > .vflex {
    margin: 0px 8px;
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    max-width: calc(100% - 133px);

    > span {
      width: 100%;
      font: ${props => props.theme.fontWeightHeavy} 14px/111% ${props => props.theme.fontFamilyBody};
      color: ${props => props.theme.secondaryColor};
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    > span.name {
      color: ${props => props.theme.bodyColor};
      font-size: 16px;
      text-transform: capitalize;
    }
  }

  & > button {
    flex-shrink: 0;
    padding: 0px 8px;
    width: 77px;
    height: 23px;
    border-radius: 2px;
    background-color: #3c4966;
    font: ${props => props.theme.fontWeightHeavy} 11px/13.2px ${props => props.theme.fontFamilyBody};
    text-transform: capitalize;
    border: none;
    color: white;

    :hover {
      color: white;
    }
  }
`;

const humanCount = d => `${humanFormat(d, { decimals: 1, separator: '' })} follower${d > 1 ? 's' : ''}`;

const Item = ({
  id, name, profilePictureUrl, followersCount, publicUrl,
}) => {
  const avatarProps = {
    id,
    name,
    publicUrl,
    profilePictureUrl,
    type: 'list',
    clickable: false,
  };
  const clickHandler = e => {
    e && e.preventDefault();
    recordSimilarContributorsStatistic(id);
    window.location = publicUrl;
  };

  return (
    <Container>
      <Avatar {...avatarProps} />
      <div className="vflex">
        <span className="name">{name}</span>
        {!!followersCount && <span>{humanCount(followersCount)}</span>}
      </div>
      <button type="button" className="btn btn-inverted" onClick={clickHandler}>
        view profile
      </button>
    </Container>
  );
};

Item.propTypes = profileTypes;
Item.defaultProps = {
  profilePictureUrl: null,
  followersCount: 0,
};

export default function ListView({ list }) {
  return (
    <>
      {list.map(prof => <Item key={prof.id} {...prof} />)}
    </>
  );
}

ListView.propTypes = { list: listTypes.isRequired };
